import { render, staticRenderFns } from "./TableBuilder.vue?vue&type=template&id=5d05cf50&"
import script from "./TableBuilder.vue?vue&type=script&lang=js&"
export * from "./TableBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports